import { Button } from '@/components/ui/shadcn/button';
import { Dialog, DialogContent, DialogDescription, DialogFooter, DialogHeader, DialogTitle } from '@/components/ui/shadcn/dialog';
import { formatCurrency } from '@/lib/utils';
import { ProjectCostLine } from '@/types';
import { useForm } from '@inertiajs/react';

interface DeleteProjectCostModalProps {
    cost: ProjectCostLine;
    isOpen: boolean;
    onClose: () => void;
}

export default function DeleteProjectCostModal({ cost, isOpen, onClose }: DeleteProjectCostModalProps) {
    const { delete: deleteAction, processing } = useForm();

    const handleDelete = () => {
        deleteAction(`/projects/${cost.project_id}/cost-lines/${cost.id}`, {
            onSuccess: () => {
                onClose();
            },
        });
    };

    return (
        <Dialog open={isOpen} onOpenChange={onClose}>
            <DialogContent className="sm:max-w-[400px]">
                <DialogHeader>
                    <DialogTitle>Delete Cost</DialogTitle>
                    <DialogDescription>Are you sure you want to delete this cost? This action cannot be undone.</DialogDescription>
                </DialogHeader>

                <div className="bg-muted/50 space-y-2 rounded-lg p-4">
                    <div className="flex justify-between text-sm">
                        <span className="text-muted-foreground">Description:</span>
                        <span className="font-medium">{cost.description}</span>
                    </div>
                    <div className="flex justify-between text-sm">
                        <span className="text-muted-foreground">Amount:</span>
                        <span className="font-medium">{formatCurrency(cost.amount)}</span>
                    </div>
                </div>

                <DialogFooter>
                    <Button type="button" variant="outline" onClick={onClose}>
                        Cancel
                    </Button>
                    <Button type="button" variant="destructive" onClick={handleDelete} disabled={processing}>
                        {processing ? 'Deleting...' : 'Delete Cost'}
                    </Button>
                </DialogFooter>
            </DialogContent>
        </Dialog>
    );
}
